import React, { useContext, useEffect, useRef } from 'react';
import { ZdsIcon, ZdsLinkCta } from '@zig-design-system/ui-components-react';
import { RootContext } from '../../Context/RootContext';
const Notification = ({ notification, onDismiss }) => {
    const bannerWrapRef = useRef();
    const getContainerClass = () => {
        const { pageContext } = useContext(RootContext);
        if (pageContext.fullWidth) {
            return 'zds-container-fluid';
        }
        return 'zds-container';
    };
    const getIcon = () => {
        const [iconLibrary, iconName] = notification.iconClass.split('_');
        return React.createElement(ZdsIcon, { className: "notification-banner__icon", library: iconLibrary, name: iconName, size: "md" });
    };
    const isWholeBannerLinkable = notification.link.href && !notification.link.text;
    const hasLink = notification.link.href && notification.link.text;
    const renderBody = () => {
        if (isWholeBannerLinkable) {
            return React.createElement("a", { href: notification.link.href }, getBodyContent());
        }
        return getBodyContent();
    };
    const getBodyContent = () => {
        return (React.createElement("div", { className: getContainerClass() },
            React.createElement("div", { className: "zds-padding-y-4" },
                React.createElement("div", { className: "zds-row" },
                    React.createElement("div", { className: "zds-col-11" },
                        notification.iconClass && getIcon(),
                        React.createElement("span", { className: "notification-banner__title zds-headline-sm zds-color-inherit" }, notification.title)),
                    notification.alwaysVisible === false && (React.createElement("div", { className: "zds-col-1 notification-banner__close-icon" },
                        React.createElement("button", { onClick: () => onDismiss(notification.id), name: 'close', type: 'button' },
                            React.createElement(ZdsIcon, { library: "fa-solid", name: "xmark", size: "sm" }))))),
                notification.message && (React.createElement("div", { className: "zds-row zds-margin-top-3" },
                    React.createElement("div", { className: "zds-body zds-col", dangerouslySetInnerHTML: { __html: notification.message } }))),
                hasLink && !isWholeBannerLinkable && (React.createElement("div", { className: "zds-margin-top-3" },
                    React.createElement(ZdsLinkCta, { onZdsClick: () => !notification.alwaysVisible && onDismiss(notification.id), link: notification.link.href }, notification.link.text))))));
    };
    useEffect(() => {
        const bannerElement = bannerWrapRef.current.firstChild;
        const timeOutId = setTimeout(() => {
            const bannerHeight = bannerElement.scrollHeight;
            bannerElement.style.height = bannerHeight + 'px';
        }, 200);
        return () => {
            clearTimeout(timeOutId);
        };
    }, []);
    return (React.createElement("div", { className: 'notification-banner-wrap' + (notification.show ? '' : ' hide'), ref: bannerWrapRef },
        React.createElement("div", { className: 'notification-banner ' + notification.backgroundClass }, renderBody())));
};
export default Notification;
